import styled from "@emotion/styled";
import LoggedInPageTemplate from "../LoggedInPageTemplate/LoggedInPageTemplate";
import SidePanel from "./SidePanel";
import { CDashboardModuleTab, SidePanelExt } from "../../types";

const CenterPanelWrapper = styled.div`
	flex-grow: 1;
	max-width: calc(100vw - 50px);
	width: calc(100vw - 50px);
	padding: 10px;
`;

const ApplicationContentWrapper = styled.div`
	min-height: calc(100vh - 20px);
	height: calc(100vh - 20px);
	overflow: auto;
	display: flex;
`;

const SidePanelWrapper = styled.div`
	width: 50px;
	z-index: 1;
	height: calc(100vh - 0px);
	max-height: calc(100vh - 0px);
	background-color: #2a2d3e;
`;

const TemplateContent = styled.div`
	display: flex;
	width: 100%;
	flex-wrap: nowrap;
`;

interface ApplicationTemplateProps {
	menuTabs: CDashboardModuleTab[];
	children: JSX.Element;
	sidePanelExt?: SidePanelExt[];
}

const ApplicationTemplate: React.FC<ApplicationTemplateProps> = ({ menuTabs, sidePanelExt, children }) => {
	return (
		<LoggedInPageTemplate>
			<TemplateContent>
				<SidePanelWrapper>
					<SidePanel menuTabs={menuTabs} sidePanelExt={sidePanelExt} />
				</SidePanelWrapper>
				<CenterPanelWrapper>
					<ApplicationContentWrapper>{children}</ApplicationContentWrapper>
				</CenterPanelWrapper>
			</TemplateContent>
		</LoggedInPageTemplate>
	);
};

export default ApplicationTemplate;
